'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {

    /**
     * One rule of LocalizedGmapsService - You don't talk about LocalizedGmapsService.
     *
     * Don't look below. And if you look below, never speak of this.
     */
    translateFormat: function translateFormat(params) {
        var format = params.format;
        var language = params.language;
        var callback = params.callback;
        var eventFired = false;
        var POLL_INTERVAL = 100;

        var iframe = document.createElement('iframe');
        iframe.style.visibility = 'hidden';

        document.body.appendChild(iframe);
        var html = '';

        html += '<head>';
        html += '<script>';
        html += 'function onGoogleDefined() {';
        html += '   google.load("maps", "3", {"other_params":"client=gme-wixcomltd2&sensor=false&libraries=places&language=' + language + '", "callback":function() {';
        html += '       var geocoder = new google.maps.Geocoder();';
        html += '       geocoder.geocode({address:decodeURIComponent("' + encodeURIComponent(format) + '")}, function(e) { window.VALUE = JSON.stringify(e); parent.postMessage(JSON.stringify(e), "*"); });';
        html += '   }});';
        html += '}';
        html += '</script>';
        html += '<script src="https://www.google.com/jsapi?client=gme-wixcomltd2&callback=onGoogleDefined" />';
        html += '<script>';
        html += '</script>';
        html += '</head>';
        html += '<body></body>';

        iframe.contentWindow.document.open();
        iframe.contentWindow.document.write(html);
        iframe.contentWindow.document.close();

        window.addEventListener("message", function (e) {
            if (e.source === iframe.contentWindow) {
                eventFired = true;
                var data = JSON.parse(e.data);
                callback(data[0].formatted_address);
            }
        });

        // Poll mechanism - needed for react native as it seems it 'eats' the messages
        var checkPoll = function checkPoll() {
            if (eventFired) return;

            try {
                var value = iframe.contentWindow.VALUE;
                if (value) {
                    eventFired = true;
                    var data = JSON.parse(value);
                    callback(data[0].formatted_address);
                    return;
                }
            } catch (e) {}
            setTimeout(checkPoll, POLL_INTERVAL);
        };

        try {
            checkPoll();
        } catch (e) {}
    }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/LocalizedGmapsService.js
// module id = 469
// module chunks = 0